import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  input,
  InputSignal,
  OnDestroy,
  OnInit,
  Renderer2,
  signal,
  ViewChild,
  WritableSignal
} from '@angular/core';
import {
  ADS_TOKEN,
  AdsProvider,
  FullHeightScrollableContainerDirective,
  PLATFORM_TOKEN,
  PlatformProvider
} from '@core';

@Component({
  selector: 'lib-close-ad-banner',
  templateUrl: './close-ad-banner.component.html',
  styleUrls: ['./close-ad-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class CloseAdBannerComponent implements OnInit, OnDestroy {
  @ViewChild('closeBannerRef') element!: ElementRef;

  readonly containerDirective: InputSignal<FullHeightScrollableContainerDirective> =
    input.required<FullHeightScrollableContainerDirective>();
  readonly bottomSpace: InputSignal<number> = input<number>(120);

  private readonly adsProvider: AdsProvider = inject(ADS_TOKEN);
  private readonly renderer2: Renderer2 = inject(Renderer2);
  private readonly platformProvider: PlatformProvider = inject(PLATFORM_TOKEN);

  readonly isVisible: WritableSignal<boolean> = signal<boolean>(false);

  ngOnInit(): void {
    // const resolvedBottomSpace = this.platformProvider.isiOS ? this.bottomSpace() + 15 : this.bottomSpace();
    //
    // this.adsProvider.bannerEvents$
    //   .pipe(
    //     filter((bannerEvent: BannerAdPluginEvents | null) => bannerEvent === BannerAdPluginEvents.AdImpression),
    //     first(),
    //     tap(() => this.isVisible.set(true)),
    //     delay(100),
    //     tap(() => this.renderer2.addClass(this.element.nativeElement, `close-ad-button`)),
    //     tap(() => this.renderer2.setStyle(this.element.nativeElement, 'bottom', `${resolvedBottomSpace}px`))
    //   )
    //   .subscribe();
  }

  ngOnDestroy(): void {
    // this.closeBanner();
  }

  closeBanner(): void {
    // this.isVisible.set(false);
    // this.adsProvider.removeBanner();
    // this.containerDirective().setStyle();
  }
}
